import useActiveState from "../../lib/useActiveState";

export default props => {
  const [user] = useActiveState('user');

  return <div className="trade-notice">
    <div className="notice-info">
      账号交易采用转移小号的形式；买入或者卖出游戏角色，不影响您的游戏主账号使用。
    </div>
    <div className="notice-process">
      <div className="title"><img src="/resources/trade/title-1.png" alt=""/>购买流程</div>
      <div className="process">
        <img src="/resources/250410/goumai.png" alt=""/>
        {/* <ul className="clearfix">
          <li>选择商品</li>
          <li>购买商品</li>
          <li>下载游戏</li>
          <li>登录游戏</li>
        </ul> */}
      </div>
      <div className="title"><img src="/resources/trade/title-2.png" alt=""/>买家须知</div>
      <div className="body">
        <p>角色描述、截图已通过官方核验。因时间因素造成的变化(排行榜、称号、装备到期等)，不视为信息失实。</p>
        <p>交易后角色直接转入您购买所使用的账号，登录游戏即可查收角色。</p>
        <p>交易过程仅限小号转移不涉及账号交易或换绑操作，无需担心购买的号被找回。</p>
        <p>购买时显示累计金额为该小号在该游戏同一小号下多个区服的角色所有累计充值。</p>
        <p>购买的小号如上一号主领取了游戏礼包和代金券的话，购买后此小号无法再二次领取使用。</p>
        <p>对同一个出售的小号每天只能议价一次，议价不得低于原价的70%。</p>
        <p>卖家改价成功后，买家会以系统消息收到提醒，或者以短信和盒子首页弹窗提醒，具体以收到的提醒为主。</p>
        <p>交易完成后，不支持退货。</p>
        <p>交易完成的小号超过72小时后才可重新上架交易。</p>
        <p>所购买的小号不支持转游/转区操作。</p>
        <p>买家须知:因买家购买过程中操作失误产生的一切损失，由买家自行承担，平台概不负责。</p>
      </div>
    </div>
    <div className="notice-process">
      <div className="title"><img src="/resources/trade/title-1.png" alt=""/>出售流程</div>
      <div className="process">
        <img src="/resources/250410/chushou.png" alt=""/>
        {/* <ul className="clearfix">
          <li>上传商品</li>
          <li>审核冻结</li>
          <li>买家购买</li>
          <li>出售成功</li>
        </ul> */}
      </div>
      <div className="title"><img src="/resources/trade/title-2.png" alt=""/>卖家须知</div>
      <div className="body">
        <p>出售小号必须实付充值满1元才能出售。</p>
        <p>提交出售申请后，待售小号在游戏中所有区服的角色都将被冻结待售，无法登录。</p>
        <p>审核不成功或您选择下架商品，可重新登录游戏获得小号。</p>
        <p>出售时显示累计金额为该小号在该游戏同一小号下多个区服的角色所有累计充值。</p>
        <p>小号出售成功后，该小号在本游戏中所有区服的角色会一同售出，但不影响该小号在其他游戏中的角色。</p>
        <p>出售成功{(()=>{
          if (parseInt(user.vip_level) == 1){
            return '会员月卡'
          }else if (parseInt(user.vip_level) == 2){
            return '会员季卡'
          }else if (parseInt(user.vip_level) == 3){
            return '会员年卡'
          }
        })()}将收取{user?.tradeRate * 100}%的手续费（会员月卡手续费降至4%/会员季卡手续费降至3%/会员年卡手续费降至2%,最低1元），剩余收益以平台币形式转至您的账号下。平台币不可提现，仅能用于游戏充值。</p>
        <p>交易完成后，不支持找回。</p>
        <p>议价消息会以APP系统消息给您通知，具体可在（APP盒子-我的-右上角消息处）查看，也可能会以短信或者首页弹窗给您提示，具体以收到的为准。</p>
        <p>待售小号一天内有三次改价机会，如果当天改价机会已用完可选择重新上架小号或者等待明日更改价格。</p>
        <p>当游戏发布停服公告或游戏问题临时下架后，该游戏的小号不论是否上架都将无法交易，且该游戏已经上架的小号将自动下架。</p>
        <p>卖家须保证所有提供信息属实，因虚假信息导致的纠纷，由卖家承担责任。</p>
        <p>卖家须知：因卖家出售过程中操作失误产生的一切损失，由卖家自行承担，平台概不负责。</p>
      </div>
    </div>
  </div>;
};